import React, { Component } from 'react';
import { withRouter } from 'react-router';
//redux
import { connect } from 'react-redux';
import { logout } from '../../action/anueInfoAction';
import Cookies from "universal-cookie";

class HeaderByLogin extends Component {

  constructor(props) {
    super(props);
    this.state = {
      minute: "",
      second: "",
      getTime: 0,
      timer: undefined
    }
  }

  componentWillMount() {
    this.startTimer();
    //this.setState({ getTime: new Date().getTime() }, () => {
    //  this.startTimer();
    //});
  }

  componentDidMount(){
    document.body.addEventListener('click', 
      function () {
        let cookie = new Cookies();
        var newDateObj = new Date(new Date().getTime() + (10 * 60 * 1000));
        cookie.set("autoLogoutTime", newDateObj.toString(), {secure: false, path:"/", sameSite: "lax"});
      }
    , true);

  }

  logoutHandler() {
    this.props.logout();
    this.props.history.push("/");
  }

  startTimer() {
    var cookie = new Cookies();
    var logouttime = new Date(cookie.get("autoLogoutTime")).getTime();
    let sec = Math.round((logouttime - new Date().getTime()) / 1000);
    if (sec === 0 || sec < 0) {
      this.logoutHandler();
      return;
    } else {
      this.setState({
        minute: Math.floor(sec / 60),
        second: ((sec % 60).toString().length === 1) ? "0" + (sec % 60) : (sec % 60),
        timer: setTimeout(() => { this.startTimer() }, 1000)
      });
    }

  }

  render() {
    return <header className="mainHeader">
      <div className="anueContainer">
        <a href="https://www.anuefund.com/" target="_blank" rel="noopener noreferrer">
          <div className="logo" />
        </a>
        <button className="logout" onClick={() => { this.logoutHandler() }} style={{ border: "none", minWidth: "76px", borderRadius: "12px", backgroundColor: "#656e79", lineHeight: "38px", color: "#2a3033", textAlign: "center", transition: "all .3s" }}>登出</button>
      </div>
      <div className="autoLogout" style={{ color: "#3e454d", right: 0, position: "absolute" }}>系統將於 {this.state.minute}:{this.state.second} 後自動登出</div>
    </header>;
  }
}
function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps, { logout })(withRouter(HeaderByLogin));